<template>
  <div id="printable">
    <v-table :row-active-id="rowActiveId" :data="tableData" :columns="columns" clickable @row-click="onRowClick">
      <template v-slot:column-time="item">
        <p v-if="item.row.isNew" :class="$style.new">
          NEW
        </p>
        {{ item.row.date | dateTime }}
      </template>
      <template v-slot:column-action="item">
        <span :class="$style.dangerous">
          <dangerous :value="item.row.statusDangerous" />
        </span>
        {{ item.row.action | action }}
      </template>
      <template v-slot:column-driveType="item">
        {{ item.row.driveType | driveType }}
      </template>
    </v-table>
    <additional-list v-if="rowActiveId" :list="additionalList" />
  </div>
</template>

<script>
import VTable from '@/components/common/table/table.vue';
import { dateTime } from '@/helpers/filters';
import AdditionalList from '@/components/common/logs/additional/list/index.vue';
import Dangerous from '@/components/common/dangerous/index.vue';
import { LogData } from '@/domains/log/data';
import { driveType, action } from './utils';

export default {
  components: {
    VTable,
    AdditionalList,
    Dangerous,
  },
  filters: {
    dateTime,
    driveType,
    action,
  },
  props: {
    data: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {
          field: 'time',
          title: this.$t('pages.columns.time'),
          sortFn: (isAsc) => (a, b) => (a.date - b.date) * (isAsc ? 1 : -1),
        },
        { field: 'action', title: this.$t('pages.columns.action') },
        { field: 'driveChar', title: this.$t('pages.columns.diskName') },
        { field: 'driveLabel', title: this.$t('pages.columns.diskLabel') },
        { field: 'driveType', title: this.$t('pages.columns.diskType') },
        { field: 'username', title: this.$t('pages.columns.username') },
      ],
    };
  },
  computed: {
    rowActiveId() {
      return parseInt(this.$route.params.record, 10);
    },
    tableData() {
      return LogData.filterTable(
        this.data,
        [
          (item) => dateTime(item.date),
          (item) => action(item.action),
          'driveChar',
          'driveLabel',
          (item) => driveType(item.driveType),
          'username',
        ],
        this.$route.query.filter,
      );
    },
    activeRow() {
      const activeRow = this.data.find((i) => i.id === this.rowActiveId);

      return activeRow || {};
    },
    additionalList() {
      const row = this.activeRow;

      return [
        [this.$t('pages.columns.time'), dateTime(row.date)],
        [this.$t('pages.columns.action'), action(row.action)],
        [this.$t('pages.columns.diskLetter'), row.driveChar],
        [this.$t('pages.columns.diskLabel'), row.driveLabel],
        [this.$t('pages.columns.diskType'), driveType(row.driveType)],
        [this.$t('pages.columns.fileSystem'), row.filesystem],
        [this.$t('pages.columns.serialNumber'), row.serial],
        [this.$t('pages.columns.username'), row.username],
      ];
    },
  },
  created() {
    this.$store.commit('logs/printData/setColumns', this.columns);
  },
  methods: {
    onRowClick(id) {
      this.$router.push({
        name: 'computers-computer-log-record',
        params: { record: id },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }

  .dangerous {
    // display: inline-block;
    margin-right: 8px;
  }
</style>
